export default __webpack_public_path__ + "static/media/foster_kinship_3.93ea7c84.jpg";